<div class="sidenav" [ngClass]="{'collapsed-sidebar': isCollapsed, 'sidebar': !isCollapsed}">
    <mat-drawer-container class="drawer-container">
        <mat-drawer class="drawer side-bar-class" mode="side" opened>
            <div class="drawer__header">
                <div class="drawer__header--icon">
                    <div class="hamburger-menu">
                        <mat-icon class="chevron-button" [ngClass]="{'rotated': isCollapsed}"
                            (click)="toggleSidebar()">chevron_left</mat-icon>
                    </div>
                    <img class="ps4-icon" src="assets/images/sect4-logo.svg" alt="Primaria Sectorului 4" />
                    <div class="drawer__header--text">
                        <div class="drawer__header--text--title">{{appName}}</div>
                        <div class="drawer__header--text--title--minWidth">PS 4</div>
                        <div class="drawer__header--text--subtitle faded-text">
                            {{appDescription}}
                        </div>
                        <div class="drawer__header--text--subtitle--minWidth faded-text">
                            inURB 4
                        </div>
                    </div>
                    <div class="drawer__header--social-container">
                        <div class="drawer__header--social" (click)="redirectToinDeskPlatform()">
                            <i class="fa-solid fa-desktop pointer" style="color: #fff"></i>
                            <span class="drawer__header--social--text faded-text pointer">inDesk</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer__buttons">
                <mat-accordion>
                    <p *ngIf="permissionsService.hasPermission('deps-module.cerere.list-all')" class="menu-link"
                        routerLink="/cereri" [class.menu-active]="'/cereri' === activeOption"
                        (click)="setActive('/cereri')">
                        <img class="sidenav-request-btn" src="../../../../assets/icons/cereri.svg" alt="" />
                        <span>Cereri</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('deps-module.plati.list')" class="menu-link"
                        routerLink="/plati" [class.menu-active]="'/plati' === activeOption"
                        (click)="setActive('/plati')">
                        <img class="sidenav-request-btn" src="../../../../assets/icons/plati.svg" alt="" />
                        <span>Plăți</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('deps-module.settings.sablon-cerere.list')"
                        class="menu-link" routerLink="/sabloane" [class.menu-active]="'/sabloane' === activeOption"
                        (click)="setActive('/sabloane')">
                        <img class="sidenav-request-btn" src="../../../../assets/icons/sablon.svg" alt="" />
                        <span>Șabloane cereri</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('deps-module.programari.list')" class="menu-link"
                        routerLink="/programari" [class.menu-active]="'/programari' === activeOption"
                        (click)="setActive('/programari')">
                        <img class="sidenav-request-btn" src="../../../../assets/icons/programari.svg" alt="" />
                        <span>Programări</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('deps-module.publicatii_casatorii.list')"
                        class="menu-link" routerLink="/publicatii-casatorii"
                        [class.menu-active]="'/publicatii-casatorii' === activeOption"
                        (click)="setActive('/publicatii-casatorii')">
                        <img class="sidenav-request-btn" src="../../../../assets/icons/icon-publicatii.svg" alt="" />
                        <span>Publicații Căsătorii</span>
                    </p>
                    <p class="menu-link" routerLink="/settings" [class.menu-active]="'/settings' === activeOption"
                        (click)="setActive('/settings')">
                        <img src="../../../../assets/icons/setari.svg" alt="" />
                        <span>Setări</span>
                    </p>

                    <ng-container *ngIf="permissionsService.hasPermission('deps-module.programari.list')">
                        <mat-expansion-panel *ngFor="let module of sidenavService.getModules()"
                            class="sidenav-accordion" (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="sidenav-accordion">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img class="panel-title-img" [src]="'../../../../assets/icons/programari.svg'"
                                            alt="" />
                                        <span>Programări {{ module.name }}</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <ng-container *ngFor="let locatieActiva of sidenavService.getLocatiiActive()">
                                <p *ngIf="locatieActiva.id_modul === module.id" class="settings-option-menu"
                                    [class.menu-active]="('/programari-view/' + locatieActiva.id) === activeOption"
                                    (click)="navigateToProgramariView(module.id, locatieActiva.id)">
                                    <img src="../../../../assets/icons/location-dot-solid.svg" alt="" />
                                    <span>{{ locatieActiva.name }}</span>
                                </p>
                            </ng-container>
                        </mat-expansion-panel>
                    </ng-container>

                    <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                        (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="../../../../assets/icons/administrative.svg" alt="" />
                                    <span>Administrativ</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="settings-option-menu" routerLink="/admin-settings"
                            [class.menu-active]="'/admin-settings' === activeOption"
                            (click)="setActive('/admin-settings')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>
                </mat-accordion>

                <div class="footer">
                    <div class="logout-button" (click)="logout()">
                        <img src="assets/icons/logout.svg" alt="Deconectare" />
                        <div click="logout()" class="logout-button--text">Deconectare</div>
                    </div>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content class="drawer-content" [style.marginLeft.px]="isCollapsed ? 85 : 280">
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</div>